import React, { useEffect, useCallback } from 'react'
import useIsMounted from '../../../../../../hooks/useIsMounted'
import PopUpBox from '../PopUpBox'
import CannotShipItems from './CannotShipItems'
import { usePopUpContext } from '../../../providers/PopUpProvider'

const defaultData = { source: 'default', state: '', items: [] }

const CheckStockByState = () => {
  const {
    showCannotShipProducts, shouldShowCannotShipProducts,
    cannotShipItems, setCannotShipItems,
  } = usePopUpContext()

  const isMounted = useIsMounted()

  const handleCheckStock = useCallback(
    () => {
      setCannotShipItems(defaultData)
      shouldShowCannotShipProducts(false)
    },
    [
      shouldShowCannotShipProducts,
      setCannotShipItems,
    ],
  )

  const handleShouldShowPopup = useCallback(
    status => {
      if (
        status === false && (
          cannotShipItems.source &&
          cannotShipItems.source.indexOf('paypal') > -1
        )
      ) {
        setCannotShipItems(defaultData)
      }
      shouldShowCannotShipProducts(status)
    },
    [cannotShipItems, shouldShowCannotShipProducts, setCannotShipItems],
  )

  useEffect(
    () => {
      if (__BROWSER__ && isMounted()) {
        handleCheckStock()
      }
    },
    [isMounted, handleCheckStock],
  )

  return (
    <PopUpBox
      showPopup={showCannotShipProducts}
      shouldShowPopup={handleShouldShowPopup}
    >
      { cannotShipItems &&
        cannotShipItems.items.length > 0 && (
        <CannotShipItems data={cannotShipItems} />
      )}
    </PopUpBox>
  )
}

export default CheckStockByState
